// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1mrvM","options":"AnswerScale_options__1Jk9f","selected":"AnswerScale_selected__3QYSt"};